export enum AnnouncementAudience {
  Enterprise = 'Enterprise',
  Supplier = 'Supplier',
  Retailer = 'Retailer',
}
